export default __webpack_public_path__ + "static/media/44.b80f651a.png";